import Swiper from "swiper";
import { Pagination, Autoplay,EffectFade } from "swiper/modules";

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".hero-slider__swiper").forEach((el) => {
    new Swiper(el, {
      modules: [Pagination, Autoplay,EffectFade],
      slidesPerView: 1,
      effect: "fade",
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: el.querySelector(".hero-slider__pagination"),
        clickable: true,
      },
    });
  });
});
